import { render } from "./AnswersSaved.vue?vue&type=template&id=160bdd18&scoped=true"
import script from "./AnswersSaved.vue?vue&type=script&lang=js"
export * from "./AnswersSaved.vue?vue&type=script&lang=js"

import "./AnswersSaved.vue?vue&type=style&index=0&id=160bdd18&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160bdd18"]])

export default __exports__